import { PlusInSquareIcon } from "assets/icons";
import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Pagination, SearchInput, Switch } from "ui";

import {
  DriversTable,
  ChangeDriverDeleteStatusModal
} from "../../components";
import { Driver } from "../../drivers.types";
import { useDriversList, useDriversBasePath } from "../../hooks";

import styles from "./Drivers.module.scss";

const Drivers = () => {
  const navigate = useNavigate();
  const basePath = useDriversBasePath();
  const isCompanyPortal = basePath === "/company/drivers";

  const {
    drivers,
    searchValue,
    setSearchValue,
    isLoading,
    sorting,
    page,
    setPage,
    totalItems,
    setSorting,
    showDeletedOnly,
    setShowDeletedOnly
  } = useDriversList();

  const [driverToChangeDeleteStatus, setDriverToChangeDeleteStatus] =
    useState<Driver | null>(null);

  const onOrderRowClick = (selectedDriver: Driver) => {
    navigate(`${basePath}/details/${selectedDriver.id}`, {
      state: window.location.search
    });
  };

  const navigateToCreateDriver = () => {
    navigate(`${basePath}/create`);
  };

  return (
    <ContentLayout
      title={t("Drivers")}
      action={
        <Button onClick={navigateToCreateDriver} icon={<PlusInSquareIcon />}>
          {t("New Driver")}
        </Button>
      }
    >
      <BoxShadowLayout className={styles.pageContent}>
        <div className={styles.pageContent_tableHeaderControls}>
          <SearchInput
            value={searchValue}
            onChange={setSearchValue}
            placeholder={t("Search...")}
          />

          {!isCompanyPortal && (
            <Switch
              label={t("Deleted Only")}
              checked={showDeletedOnly}
              onChange={(e) => setShowDeletedOnly(e.target.checked)}
            />
          )}
        </div>

        <DriversTable
          driversList={drivers ?? []}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
          onRowClick={onOrderRowClick}
          onChangeDeleteStatus={setDriverToChangeDeleteStatus}
          isDeletedOnly={showDeletedOnly}
        />

        <Pagination
          currentPage={page}
          onChange={setPage}
          perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
          totalItems={totalItems}
        />
      </BoxShadowLayout>

      <ChangeDriverDeleteStatusModal
        id={String(driverToChangeDeleteStatus?.id)}
        isOpen={Boolean(driverToChangeDeleteStatus)}
        onClose={() => setDriverToChangeDeleteStatus(null)}
        action={driverToChangeDeleteStatus?.isDeleted ? "Restore" : "Delete"}
      />
    </ContentLayout>
  );
};

export default Drivers;
